import React from "react";
import { Icon, Segment, Message } from "semantic-ui-react";
import { animateScroll } from "react-scroll";
import _ from "lodash";

import CommentForm from "./CommentForm";
import MessagesService from "../services/messages";

class CommentBox extends React.Component {
  constructor() {
    super();
    this.service = new MessagesService();
    this.limitDisplayComments = 5;
    this.state = {
      comments: [],
    };
  }

  componentDidMount() {
    setInterval(() => this.messageList(), 5000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.comments.length === 0) {
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    animateScroll.scrollToBottom({
      containerId: "list-comments",
    });
  }

  messageList() {
    this.service
      .getMessages(this.props.liveId, this.limitDisplayComments)
      .then((response) => {
        this.setState({
          comments: _.orderBy(response.data, ["timestamp"], ["asc"]),
        });
      })
      .catch((err) => {
        console.log(`Ops! ocorreu um erro: ${err}`);
      });
  }

  renderCommnents() {
    return this.state.comments
      .filter(function (comment) {
        return comment.moderated === "S";
      })
      .map((comment) => {
        let user = (
          <>
            {_.startCase(comment.username)}&nbsp;&nbsp;&nbsp;
            {comment.is_owner === "S" ? (
              <Icon color="green" name="certificate" />
            ) : (
              ""
            )}
          </>
        );
        return (
          <Message
            size="small"
            header={user}
            content={comment.content}
            key={comment.id}
          />
        );
      });
  }

  render() {
    const comments = this.renderCommnents();

    return (
      <Segment.Group size="mini">
        <Segment className="list-comments" id="list-comments">
            {comments}
        </Segment>
        <Segment className="form-comment">
          <CommentForm
            addComment={this._addComment.bind(this)}
            username={this.props.username}
            popUpFunctionName={this.props.popUpFunctionName}
          />
        </Segment>
      </Segment.Group>
    );
  }

  _addComment(username, content) {
    const comment = {
      liveId: this.props.liveId,
      username,
      content,
      moderated: this.props.notModerated === "true" ? "S" : "N",
      isOwner: this.props.isOwner === "true" ? "S" : "N",
    };
    console.log(comment);
    this.service
      .saveMessage(comment)
      .then((response) => {
        console.log(response);
        if (this.props.notModerated === "true") {
          let newList = _.concat(this.state.comments, [response.data]);
          this.setState({
            comments: _.orderBy(newList, ["timestamp"], ["asc"]),
          });
          this.scrollToBottom();
          this.setState({
            limitDisplayComments: this.limitDisplayComments++
          })
        } else {
          if (!_.isNull(this.props.popUpModerated)) {
            window.parent.postMessage(
              {
                func: this.props.popUpModerated,
                message: "open_moderated_popup",
              },
              "*"
            );
          }
        }
      })
      .catch((err) => {
        console.log(`Ops! ocorreu um erro: ${err}`);
      });
  }
}

export default CommentBox;
